if (!customElements.get('anniversary-giveaway-form')) {
  class AnniversaryGiveawayForm extends HTMLElement {
    connectedCallback() {
      this.abortController?.abort();
      this.observer?.disconnect();

      this.abortController = new AbortController();
      this.arrowTemplate = this.querySelector('[data-arrow-template]');

      this.addEventListener('pointerdown', this.handleBlockedSubmission, {
        capture: true,
        signal: this.abortController.signal,
      });
      this.addEventListener('submit', this.handleBlockedSubmission, {
        capture: true,
        signal: this.abortController.signal,
      });

      this.observer = new MutationObserver(() => this.sync());
      this.observer.observe(this, { childList: true, subtree: true });
      this.sync();
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.focusFrame);
    }

    sync() {
      const input = this.querySelector('input[type="email"], input[autocomplete="email"]');
      const button = this.querySelector('button');
      const styleProps = [
        'width',
        'min-width',
        'max-width',
        'flex',
        'flex-basis',
        'flex-grow',
        'flex-shrink',
        'flex-direction',
      ];

      this.querySelectorAll(
        '[data-testid="form-row"], [data-testid="form-component"], input[type="email"], input[autocomplete="email"], button',
      ).forEach((element) => {
        styleProps.forEach((property) => element.style.removeProperty(property));
      });

      if (input && this.dataset.placeholder) {
        input.placeholder = this.dataset.placeholder;
      }

      if (!button) return;

      button.classList.add('anniversary-giveaway__submit');

      if (this.dataset.submitLabel && button.dataset.anniversaryGiveawayLabel !== this.dataset.submitLabel) {
        button.replaceChildren(document.createTextNode(this.dataset.submitLabel));
        button.dataset.anniversaryGiveawayLabel = this.dataset.submitLabel;
      }

      if (!button.querySelector('.anniversary-giveaway__submit-icon') && this.arrowTemplate?.content) {
        button.append(this.arrowTemplate.content.cloneNode(true));
      }
    }

    handleBlockedSubmission = (event) => {
      let button;

      if (event.type === 'submit') {
        button = this.querySelector('button.anniversary-giveaway__submit:disabled');
      } else if (event.target instanceof Element) {
        button = event.target.closest('button.anniversary-giveaway__submit:disabled');
      }

      if (!button) return;

      event.preventDefault();
      this.focusConsent();
    };

    focusConsent() {
      const checkbox = this.closest('.anniversary-giveaway__form-area')?.querySelector(
        '[data-consent-gate-checkbox]',
      );
      if (!checkbox) return;

      cancelAnimationFrame(this.focusFrame);
      this.focusFrame = requestAnimationFrame(() => checkbox.focus({ preventScroll: true }));
    }
  }

  customElements.define('anniversary-giveaway-form', AnniversaryGiveawayForm);
}
